
<button class="go-top1 border-0" *ngIf="isShow" (click)="gotoTop()">
    <i class="ri-arrow-up-s-line"></i>
  </button>